import { useFrame } from '@react-three/fiber'
import { useRef } from 'react'

type SceneReadyBridgeProps = {
    onReady?: () => void
}

export function SceneReadyBridge({ onReady }: SceneReadyBridgeProps) {
    const readyRef = useRef(false)

    useFrame(() => {
        if (readyRef.current || !onReady) {
            return
        }

        readyRef.current = true
        onReady()
    }, 1)

    return null
}
